import React, { useState } from 'react';

function StrikeThroughButton({id, title = "default", google_id,  note = "default_note", date = "mm/dd/yyyy", click }) {
    // State to track if the checkbox is checked
    const [isChecked, setIsChecked] = useState(false);
    const parseDate = (isoDate) => {
        if (isoDate === "mm/dd/yyyy") {
            return isoDate
        }
        if(!isoDate){
            return ""
        }
        const date = new Date(isoDate);

        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getUTCDate()).padStart(2, '0');
        const year = date.getUTCFullYear();

        return `${month}/${day}/${year}`;
    }
    // Function to handle button click
    const handleClick = () => {
        click()
        setIsChecked(!isChecked);
    };

    return (
        <div onClick={handleClick} google_id={google_id} className="flex items-center text-center space-x-4 bg-red-500 w-full p-2 rounded-lg">
            <input
                type="checkbox"
                className="ml-4"
                checked={isChecked}
                readOnly
            />
            <button
                
                className={`py-2 px-4 rounded text-s xs:text-lg text-white text-left font-bold transition-all duration-300 ${isChecked ? 'line-through' : ''
                    }`}
            >
                {title}

                <p className="font-light text-xs xs:text-md">{parseDate(date)}</p>
                <p className="font-light text-s xs:text-md">{note}</p>
            </button>
        </div>
    );
}

export default StrikeThroughButton;
